import languages from './isoLanguageToText.json'

// Returns the language name for a given ISO code.
export function getLanguageName(isoCode: string): string {
  return (languages as Record<string, string>)[isoCode] || 'Unknown language'
}
